import {
  sendConfigRequest
} from "../../static/utils/http.js"
import Vue from 'vue';
export default {
  /**
   * 查询游客注册配置信息
   * @constructor
   */
  async getScanConfigList({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      sendConfigRequest({
        'requestUri': '/config/getScanConfigList',
        'requestType': 'get',
        'requestShowLoading': false,
        'showMessageType': 3,
        'getDataFromAPICallback': function(data, success, message, code) {
          if (success) {
            let isscanprice = ''
            let isscan = ''
            if (!!data) {
              app_userManage.setUserProperty_toLocalStorage(_ScanConfigList, data);
              for (var i = 0; i < data.length; i++) {
                if (data[i].name == "isscanprice") {
                  isscanprice = data[i].value == 1
                  commit("setIsscanprice", data[i].value == 1);
                } else if (data[i].name == "isscan") {
                  isscan = data[i].value == 1
                  commit("setIsscan", data[i].value == 1);
                }
              }
            }
            resolve({isscan, isscanprice})
          } else {
            if (!!message) {
              Vue.$vux.toast.show({
                text: message
              })
            }
          }
        },
        'manageCode': true, //处理code
        'requestFailCallback': function(error) {},
      });
    })
  },
  /*获取商户开放的购买方式权限*/
  getOpenPurchaseConfig({commit}) {
    return new Promise((resolve, reject) => {
      sendConfigRequest({
        'requestUri': '/config/openPurchaseConfig',
        'requestType': 'get',
        'requestShowLoading': true,
        'getDataFromAPICallback': function(data, success, message, code) {
          if (code == 200 && success) {
            commit("setOpenPurchaseConfig", data);
            resolve(data)
          } else {
            if (message != null) {
              Vue.$vux.toast.show({
                text: message
              })
            }
          }
        },
        'requestFailCallback': function(error) {
          console.log(error)
        }
      })
    })
  },
  /**
   *查询商家配置信息
   *包含小数点尾数和开票信息
   */
  getSysConfigList({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      sendConfigRequest({
        'requestUri': '/config/getSysConfigList',
        'requestType': 'get',
        'requestShowLoading': false,
        'requestData': {},
        'getDataFromAPICallback': function(data, success, message, code) {
          if (success) {
            if (!!data) {
              let invoicetax, vattax, qtyDigit, priceDigit;
              data.map((item) => {
                if (item.name == "invoicetax") {
                  invoicetax = item.value;
                } else if (item.name == "vattax") {
                  vattax = item.value;
                } else if (item.name == "qtydigit") {
                  qtyDigit = Number(item.value);
                } else if (item.name == "pricedigit") {
                  priceDigit = Number(item.value);
                }
              })
              let ticketTypesData = [{
                value: 1,
                text: '不开票',
                tax: 100
              }]
              data.map((item) => {
                if (item.name == "enableinvoice") {
                  if (item.value == 1) {
                    ticketTypesData.push({
                      value: 2,
                      text: '普通发票(税点' + invoicetax + '%)',
                      tax: invoicetax
                    });
                  }
                } else if (item.name == "enablevat") {
                  if (item.value == 1) {
                    ticketTypesData.push({
                      value: 3,
                      text: '增值税专票(税点' + vattax + '%)',
                      tax: vattax
                    });
                  }
                }
              })
              commit("setTicketTypesData", ticketTypesData)
              commit("setDigit", {qtyDigit, priceDigit})
              resolve({ ticketTypesData, qtyDigit, priceDigit})
            }
          } else {
            if (!!message) {
              Vue.$vux.toast.show({
                text: message
              })
            }
          }
        },
        'requestFailCallback': function(error) {},
      });
    })
  },
  /*获取商户主题广告配置信息*/
  getThemeConfig({dispatch, commit}) {
    return new Promise((resolve, reject) => {
      sendConfigRequest({
        'requestUri': '/config/selectFxConfig',
        'requestType': 'get',
        'requestShowLoading': true,
        'getDataFromAPICallback': function(data, success, message, code) {
          if (success) {
            if (data != null) {
              let themeFlag = 'happyRed'
              switch(data.theme) {
                case 1:
                  themeFlag = 'happyRed'
                  break
                case 2:
                  themeFlag = 'blackGold'
                  break
                case 3:
                  themeFlag = 'technologyBlue'
                  break
                default:
                  themeFlag = 'happyRed'
              }
              commit("setThemeConfig", {
                themeFlag: themeFlag,
                isHasLoading: data.img ? true : false,
                loadingTime: data.retentionTime ? data.retentionTime * 1000 : 1000,
                adImg: data.img ? data.img : '../static/img/loading.png'
              }); //设置主题
            }
            resolve()
          } else {
            if (message != null) {
              Vue.$vux.toast.show({
                text: message
              })
            }
          }
        },
        'requestFailCallback': function(error) {}
      });
    })
  },
  /*查询商户信息*/
  getGetsellerCompanyInfo({dispatch, commit}) {
    sendConfigRequest({
      'requestUri': '/account/company',
      'requestType': 'get',
      'requestShowLoading': true,
      'getDataFromAPICallback': function(data, success, message, code) {
        if (success) {
          if (data != null) {
            if (!!data.website && data.website.indexOf('http://') == -1) {
              data.website = 'http://' + data.website
            }
            commit("setGetsellerCompanyInfo", data);
            window.localStorageUtil.setItem(_seller_company_info, data);
            document.querySelector("title").innerText = data.companyName;
          }
        } else {
          if (message != null) {
            Vue.$vux.toast.show({
              text: message
            })
          }
        }
      },
      'requestFailCallback': function(error) {}
    });
  },
  /*查询商户公司名称*/
  getCompanyBriefInfo() {
    sendConfigRequest({
      'requestUri': '/account/getCompanyBriefInfo',
      'requestType': 'get',
      'requestShowLoading': true,
      'getDataFromAPICallback': function(data, success, message, code) {
        if (success) {
          if (data != null) {
            window.localStorageUtil.setItem('companyName', data.companyName);
            document.querySelector("title").innerText = data.companyName;
          }
        } else {
          if (message != null) {
            Vue.$vux.toast.show({
              text: message
            })
          }
        }
      },
      'requestFailCallback': function(error) {}
    });
  },
  /*获取购物车数量*/
  getShoppingCartQty({dispatch, commit}) {
    sendConfigRequest({
      'requestUri': '/shoppingCart/count',
      'requestType': 'get',
      'requestShowLoading': false,
      'showMessageType': 3,
      'getDataFromAPICallback': function(data, success, message, code) {
        if (success) {
          commit("setShoppingCartQty", data.toString());
        } else {
          if (!!message) {
            Vue.$vux.toast.show({
              text: message
            })
          }
        }
        return false;
      },
      'manageCode': true, //处理code
      'requestFailCallback': function(error) {},
    });
  },

}



// WEBPACK FOOTER //
// ./src/store/actions.js